import { FunctionDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const MockError = () => (
  <FunctionDocs entry="mockError">
    <ComponentExample
      name="Error message with code"
      description="An optional numeric code can be specified with the error."
      import={import("examples/Api/MockError/ErrorMessageWithCodeExample")}
      rawImport={import(
        "examples/Api/MockError/ErrorMessageWithCodeExample?raw"
      )}
    />
  </FunctionDocs>
);

export default MockError;
